import { createStyles, StyleRules } from '@mui/styles';

const styles = (): StyleRules =>
  createStyles({
    issueTableWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
    },
  });

export default styles;
